var exports = {
  "kL": "xfd349460--3e3c9a--container",
  "ZZ": "xfd349460--3e3c9a--field",
  "tu": "xfd349460--3e3c9a--adornment",
};

module.exports = exports;
